import { Step } from "../../components/Stepper/Stepper";
import {
  STEP_1_LOGO_COLORS,
  STEP_5_MKTG_AUTO
} from "../../app/19_JetpackConfig/constants";
import { SaasFeatures } from "@tootsweet/model/entities/SubscriptionPlan";

export function filterStepsByFeatures(
  step: Step,
  saasFeatures: SaasFeatures | undefined | null,
  price?: number | undefined | null
) {
  if (!saasFeatures || Object.entries(saasFeatures).length === 0) {
    return true;
  }

  if (!saasFeatures?.t && step.index === STEP_1_LOGO_COLORS) {
    return false;
  }

  if (step.index === STEP_5_MKTG_AUTO) {
    if (saasFeatures?.ip) {
      return true;
    }

    if (!!saasFeatures?.lty && price && price > 0) {
      return true;
    }

    return false;
  }

  return true;
}
